import { Buffer } from "buffer";

import RequestAbstract from "./RequestAbstract";

export default class Auth extends RequestAbstract {
    async login(info = {}) {
        const { loginAuthClient, loginAuthSecret } = this._config;
        const authToken = "Basic " + Buffer.from(`${loginAuthClient}:${loginAuthSecret}`).toString("base64");

        return await this.postForm(
            this.links.token,
            { ...info },
            { 'Authorization': authToken, }
        );
    }
}
